var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',[_c('service-header',{attrs:{"service":_vm.service,"scope":_vm.scope}}),_vm._v(" "),_c('v-divider'),_vm._v(" "),(_vm.isOffer)?[_c('service-meta',{attrs:{"service":_vm.service}}),_vm._v(" "),_c('service-content',{attrs:{"service":_vm.service}}),_vm._v(" "),_c('v-divider')]:_vm._e(),_vm._v(" "),_c('service-actions',{attrs:{"service":_vm.service}})],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2c184f95","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/service/Card.vue
// module id = null
// module chunks = 